export default __webpack_public_path__ + "static/media/GY.c80833be.svg";